import { Link } from '@packages/modules/src/Link/Link';
import { useTrackCampaignOnLoad } from '@packages/shared/src/hooks/useTrackCampaign/useTrackCampaign';
import { useConfig } from '@packages/shared/src/hooks/useConfig/useConfig';
import { useEffect } from 'react';
import type { ServiceMenuEntry } from './ServiceMenuTypes';
import { useServiceMenuData } from './useServiceMenuData';

const ServiceSlotMenuItem = ({ data }: { data: ServiceMenuEntry }) => {
  const { translatable_title: title, translatable_url: url, is_external: isExternal } = data;
  const finalLink = url ?? '';
  const { trackClick, trackDisplay } = useTrackCampaignOnLoad(data, finalLink);

  useEffect(() => {
    if (url) {
      trackDisplay();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div role="menuitem" className="hover:bg-color-grey-light">
      <Link
        href={finalLink}
        key={title}
        openInNewTab={isExternal}
        {...(url && { onClick: () => trackClick() })}
      >
        <div className="text-size-body2 p-1">{title}</div>
      </Link>
    </div>
  );
};

export const ServiceSlotMenuList = () => {
  const {
    headerSlots: { serviceApi },
  } = useConfig();

  const data = useServiceMenuData(serviceApi);

  return (
    <div role="menu">
      {data.map((dataItem) => (
        <ServiceSlotMenuItem
          // NOTE theoretically each drupal item would have a unique id, but the id is currently not exposed
          key={dataItem.translatable_title}
          data={dataItem}
        />
      ))}
    </div>
  );
};
